{
  "CHAT_LIST": {
    "LOADING": "Отримання бесід",
    "LOAD_MORE_CONVERSATIONS": "Завантажити більше бесід",
    "EOF": "Всі бесіди завантажені 🎉",
    "LIST": {
      "404": "В цій групі немає активних бесід."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Бесіди",
    "MENTION_HEADING": "Згадування",
    "UNATTENDED_HEADING": "Без відповіді",
    "SEARCH": {
      "INPUT": "Пошук людей, чатів та збережених відповідей.."
    },
    "FILTER_ALL": "Всі",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Мої",
      "unassigned": "Непризначені",
      "all": "Всі"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Відкриті"
      },
      "resolved": {
        "TEXT": "Вирішені"
      },
      "pending": {
        "TEXT": "Очікує"
      },
      "snoozed": {
        "TEXT": "Відкладено"
      },
      "all": {
        "TEXT": "Всі"
      }
    },
    "VIEW_FILTER": "Вигляд",
    "SORT_TOOLTIP_LABEL": "Відсортувати розмови",
    "CHAT_SORT": {
      "STATUS": "Статус",
      "ORDER_BY": "Сортувати за"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Створено",
        "OLDEST": "Створений в:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Остання активність:",
        "ACTIVE": "Остання активність"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Остання активність: спочатку старіші"
      },
      "last_activity_at_desc": {
        "TEXT": "Остання активність: спочатку нові"
      },
      "created_at_desc": {
        "TEXT": "Створено: спочатку нові"
      },
      "created_at_asc": {
        "TEXT": "Створено у: спочатку старіші"
      },
      "priority_desc": {
        "TEXT": "Пріоритет: спочатку найвищий"
      },
      "priority_asc": {
        "TEXT": "Пріоритет: спочатку низький"
      },
      "waiting_since_asc": {
        "TEXT": "Очікує відповіді: спочатку довгі"
      },
      "waiting_since_desc": {
        "TEXT": "Очікує відповіді: спершу короткі"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      },
      "unread": {
        "TEXT": "Unread Count: Highest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Повідомлення з картинкою"
      },
      "audio": {
        "CONTENT": "Аудіо-повідомлення"
      },
      "video": {
        "CONTENT": "Відеоповідомлення"
      },
      "file": {
        "CONTENT": "Повідомлення з файлом"
      },
      "location": {
        "CONTENT": "Місцезнаходження"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "поділився посиланням"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Вбудований вміст"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Відсортувати розмови",
      "DROPDOWN_TITLE": "Сортувати за",
      "ITEMS": {
        "LATEST": {
          "NAME": "Остання активність о",
          "LABEL": "Остання активність"
        },
        "CREATED_AT": {
          "NAME": "Створений в",
          "LABEL": "Створений в"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Дата останнього повідомлення",
          "LABEL": "Останнє повідомлення"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Отримано електронною поштою",
    "VIEW_TWEET_IN_TWITTER": "Переглянути твіт у Twitter",
    "REPLY_TO_TWEET": "Відповісти на цей твіт",
    "LINK_TO_STORY": "Перейти до історії Instagram",
    "SENT": "Успішно надіслано",
    "READ": "Успішно прочитано",
    "DELIVERED": "Успішно доставлено",
    "NO_MESSAGES": "Немає повідомлень",
    "NO_CONTENT": "Немає вмісту",
    "HIDE_QUOTED_TEXT": "Приховати цитований текст",
    "SHOW_QUOTED_TEXT": "Показати цитований текст",
    "MESSAGE_READ": "Прочитано",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
